export const singlePageThemeAttributes = {
	section: {
		padding: {
			top: [80, 120],
			bottom: [80, 120],
		},
		margin: {
			top: [-40, -60],
		},
	},
};

export const SinglePageThemeControls = {
	// name of the block
	title: 'Single Page',

	// slug of the block (= the key used in theme.json)
	slug: 'singlePage',

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: singlePageThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
